<template>
  <div class="fillIn">
    <v-head></v-head>
    <div class="contentBox">
      <div class="introduce">
        <div>
          <p class="tit"><span>产品名称</span> {{ detailsData.productName }}</p>
          <p>
            承保公司：<span>{{ detailsData.companyName }}</span>
          </p>
          <p style="display: block;">
            不属于承保范围行业：<span>
              {{ detailsData.nonInsured }}
            </span>
          </p>
          <template
            v-if="
              id == '1001371' ||
                id == '1001370' ||
                id == '1001380' ||
                id == '1001379'
            "
          >
            <p>属于承保范围地区：<span> 中国大陆，不含港澳台 </span></p>
          </template>
          <template v-else>
            <p>
              拒保地区（企业注册地）：<span> {{ detailsData.noInsureArea }} </span>
            </p>
            <template v-if="detailsData.workAddress">
            <p>
                拒保施工地：<span> {{ detailsData.workAddress }} </span>
            </p>
            </template>
          </template>
          <p>
            职业类别：
            <a
              v-for="item in detailsData.occupationCate"
              :key="item.uid"
              :href="item.url"
              target="_blank"
              download
            >
              《职业类别》
            </a>
          </p>
        </div>
      </div>
      <div class="stepBox">
        <p>
          <img src="@/assets/images/product/stepbg1_a.png" alt="" />
          <span> 1、填写投保信息 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg2.png" alt="" />
          <span> 2、上传投保资料 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg2.png" alt="" />
          <span> 3、支付保费 </span>
        </p>
        <p>
          <img src="@/assets/images/product/stepbg3.png" alt="" />
          <span> 4、完成 </span>
        </p>
      </div>
      <div class="insureStap">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          size="small"
          label-width="140px"
        >
          <div class="stapTit" :class="step1 ? '' : 'show'">
            <p>填写投保企业信息</p>
            <span @click="step1 = false" v-if="step1">
              收起 <i class="iconfont icon-shouqi"></i>
            </span>
            <span @click="step1 = true" v-else>
              展开 <i class="iconfont icon-zhankai"></i>
            </span>
          </div>
          <div class="setpContent one" v-show="step1">
            <div class="left">
              <el-form-item label="营业执照名称：" prop="applicationName">
                <el-input
                  v-model.trim="form.applicationName"
                  @change="changeBill"
                  ></el-input>
                  <!-- :disabled="isPolicyHolder == 1" -->
              </el-form-item>
              <el-form-item label="统一信用代码：" prop="applicationCode">
                <el-input
                  v-model.trim="form.applicationCode"
                  :disabled="isPolicyHolder == 1"
                  @change="changeBill"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人/联系人：" prop="applicationLegalPerson">
                <el-input
                  v-model="form.applicationLegalPerson"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号码：" prop="applicationPhone">
                <el-input
                  v-model="form.applicationPhone"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item label="地区：" prop="applicationPCA">
                <el-cascader
                  v-model="form.applicationPCA"
                  :options="regionArray"
                  :props="{ children: 'child', label: 'name', value: 'id' }"
                  filterable
                  style="width:100%"
                  popper-class="cascaderRegion"
                  :disabled="isPolicyHolder == 1"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item label="经营地址：" prop="applicationAddress">
                <el-input
                  v-model="form.applicationAddress"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="经办人身份证号："
                prop="applicationLeagronCard"
                v-if="detailsData.isNeedIdCard == 1"
              >
                <el-input
                  v-model="form.applicationLeagronCard"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="经办人邮箱："
                prop="applicationMailbox"
                v-if="detailsData.isNeedIdCard == 1"
              >
                <el-input
                  v-model="form.applicationMailbox"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item label="经营范围：" prop="businessSite">
                <el-input
                  v-model="form.businessSite"
                  :disabled="isPolicyHolder == 1"
                ></el-input>
              </el-form-item>
              <el-form-item label="施工地点" prop="shigongdidian" v-if="detailsData.shigongdidian == '1'">
                <el-input v-model="form.shigongdidian"></el-input>
              </el-form-item>
              <el-form-item>
                <el-checkbox
                  v-model="form.same"
                  :true-label="1"
                  :false-label="0"
                  @change="changeSame"
                >
                  被保企业同投保企业
                </el-checkbox>
              </el-form-item>
            </div>
            <div class="right">
              <div class="commoSelect">
                <p>常用联系人：</p>
                <el-select
                  v-model="contacts"
                  placeholder="再次投保，可直接选择企业，无需填写"
                  style="width:calc(100% - 90px)"
                  :disabled="isPolicyHolder == 1"
                  size="small"
                  filterable
                  @change="commonSelect1"
                >
                  <el-option
                    v-for="(item, index) in applicationList"
                    :key="index"
                    :label="item.name"
                    :value="index"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-form-item prop="applicationCodeImg" class="lm0">
                <!-- 电子签章是否已认证 -->
                <div class="ESignature" v-if="NoFollow">
                  <div class="approve" v-if="!certification">
                    <img src="@/assets/images/product/unverified.png" alt="" />
                    <i class="el-icon-info" @click="ishint = true"></i>
                  </div>
                  <div class="NoApprove" v-else>
                    <img src="@/assets/images/product/certified.png" alt="" />
                  </div>
                </div>
                <el-upload
                  drag
                  action="/api/upload/upload"
                  name="file"
                  multiple
                  accept="image/jpeg,image/gif,image/png"
                  :http-request="upload"
                  :file-list="oneList"
                  :disabled="isPolicyHolder == 1"
                  :on-remove="handleRemove1"
                  :show-file-list="false"
                >
                  <img src="@/assets/images/product/upload.png" alt="" />
                  <div class="el-upload__text">
                    将营业执照拖到此处，或 <em>点击上传</em>
                  </div>
                  <p>图片最大文件上传不得超过100M，支持jpg、png、jpeg格式！</p>
                  <!-- <div class="el-upload__tip" slot="tip">
                    请先上传营业执照，上传营业执照自动识别信息
                  </div> -->
                </el-upload>
                <ul class="el-upload-list el-upload-list--picture custom">
                  <li
                    tabindex="0"
                    class="el-upload-list__item is-success"
                    v-for="(item, index) in oneList"
                    :key="index"
                  >
                    <el-image
                      style="width: 70px; height: 70px"
                      :src="item.url"
                      :preview-src-list="[item.url]"
                    >
                    </el-image>
                    <a class="el-upload-list__item-name">
                      <i class="el-icon-document"></i>
                      {{ item.name }}
                    </a>
                    <label class="el-upload-list__item-status-label">
                      <i class="el-icon-upload-success el-icon-check"> </i>
                    </label>
                    <i class="el-icon-close" @click="handleRemove1()"></i>
                  </li>
                </ul>
              </el-form-item>
            </div>
          </div>
          <template v-if="form.same == 0">
            <div class="stapTit" :class="step2 ? '' : 'show'">
              <p>填写被保企业信息</p>
              <span @click="step2 = false" v-if="step2">
                收起 <i class="iconfont icon-shouqi"></i>
              </span>
              <span @click="step2 = true" v-else>
                展开 <i class="iconfont icon-zhankai"></i>
              </span>
            </div>
            <div class="setpContent two" v-show="step2">
              <div class="left">
                <el-form-item label="营业执照名称：" prop="insuredName">
                  <el-input v-model.trim="form.insuredName"></el-input>
                </el-form-item>
                <el-form-item label="统一信用代码：" prop="insuredCode">
                  <el-input v-model.trim="form.insuredCode"></el-input>
                </el-form-item>
                <el-form-item label="法人/联系人：" prop="insuredLegalPerson">
                  <el-input v-model="form.insuredLegalPerson"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="insuredPhone">
                  <el-input v-model="form.insuredPhone"></el-input>
                </el-form-item>
                <el-form-item label="地区：" prop="insuredPCA">
                  <el-cascader
                    v-model="form.insuredPCA"
                    :options="regionArray"
                    :props="{ children: 'child', label: 'name', value: 'id' }"
                    filterable
                    style="width:100%"
                    popper-class="cascaderRegion"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="经营地址：" prop="insuredAddress">
                  <el-input v-model="form.insuredAddress"></el-input>
                </el-form-item>
                <el-form-item
                  label="经办人身份证号："
                  prop="insuredLeagronCard"
                  v-if="detailsData.isNeedIdCard == 1"
                >
                  <el-input v-model="form.insuredLeagronCard"></el-input>
                </el-form-item>
                <el-form-item
                  label="经办人邮箱："
                  prop="insuredMailbox"
                  v-if="detailsData.isNeedIdCard == 1"
                >
                  <el-input v-model="form.insuredMailbox"></el-input>
                </el-form-item>
                <el-form-item label="经营范围：" prop="insuredBusinessSite">
                  <el-input v-model="form.insuredBusinessSite"></el-input>
                </el-form-item>
              </div>
              <div class="right">
                <div class="commoSelect">
                  <p>常用联系人：</p>
                  <el-select
                    v-model="contacts2"
                    placeholder="再次投保，可直接选择企业，无需填写"
                    style="width:calc(100% - 90px)"
                    size="small"
                    filterable
                    @change="commonSelect2"
                  >
                    <el-option
                      v-for="(item, index) in insuredList"
                      :key="index"
                      :label="item.name"
                      :value="index"
                    >
                    </el-option>
                  </el-select>
                </div>
                <el-form-item prop="insuredCodeImg" class="lm0">
                  <el-upload
                    drag
                    action="/api/upload/upload"
                    name="file"
                    multiple
                    accept="image/jpeg,image/gif,image/png"
                    :http-request="upload2"
                    :file-list="twoList"
                    :on-remove="handleRemove2"
                    :show-file-list="false"
                  >
                    <img src="@/assets/images/product/upload.png" alt="" />
                    <div class="el-upload__text">
                      将营业执照拖到此处，或 <em>点击上传</em>
                    </div>
                    <p>
                      图片最大文件上传不得超过100M，支持jpg、png、jpeg格式！
                    </p>
                    <!-- <div class="el-upload__tip" slot="tip">
                      请先上传营业执照，上传营业执照自动识别信息
                    </div> -->
                  </el-upload>
                  <ul class="el-upload-list el-upload-list--picture custom">
                    <li
                      tabindex="0"
                      class="el-upload-list__item is-success"
                      v-for="(item, index) in twoList"
                      :key="index"
                    >
                      <el-image
                        style="width: 70px; height: 70px"
                        :src="item.url"
                        :preview-src-list="[item.url]"
                      >
                      </el-image>
                      <a class="el-upload-list__item-name">
                        <i class="el-icon-document"></i>
                        {{ item.name }}
                      </a>
                      <label class="el-upload-list__item-status-label">
                        <i class="el-icon-upload-success el-icon-check"> </i>
                      </label>
                      <i class="el-icon-close" @click="handleRemove2()"></i>
                    </li>
                  </ul>
                </el-form-item>
              </div>
            </div>
          </template>
          <div class="stapTit" :class="step3 ? '' : 'show'">
            <p>选择保险产品，确认总保费</p>
            <span @click="step3 = false" v-if="step3">
              收起 <i class="iconfont icon-shouqi"></i>
            </span>
            <span @click="step3 = true" v-else>
              展开 <i class="iconfont icon-zhankai"></i>
            </span>
          </div>
          <div class="setpContent three" v-show="step3">
            <div class="top ">
              <div class="left">
                <el-form-item label="起保日期：" prop="sTime">
                  <el-date-picker
                    v-model="form.sTime"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="职业类别：" prop="workType">
                  <el-select
                    filterable
                    v-model="form.workType"
                    placeholder="请选择职业类别"
                    size="small"
                    @change="changeWorkCateIds"
                  >
                    <el-option
                      v-for="(item, index) in workTypeArray"
                      :key="index"
                      :label="item.value"
                      :value="item.ids.join('-')"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="right">
                <el-form-item
                  label="保障期限："
                  prop="guaranteePeriod"
                  label-width="100px"
                >
                  <el-select
                    filterable
                    v-model="form.guaranteePeriod"
                    placeholder="请选择保障期限"
                    @change="getProductPlanMoney"
                  >
                    <el-option
                      v-for="(item, index) in monthArray"
                      :key="index"
                      :label="item + '个月'"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  label="选择职业："
                  prop="workId"
                  label-width="100px"
                >
                  <el-cascader
                    v-model="form.workId"
                    :options="optionsArray"
                    :key="cascaderKey"
                    :props="{ children: 'child', label: 'title', value: 'id' }"
                    filterable
                    :show-all-levels="false"
                    clearable
                    @change="getProductPlanMoney"
                  >
                  </el-cascader>
                </el-form-item>
              </div>
            </div>
            <div class="contentArea">
              <el-table
                :data="plan"
                style="width: 100%"
                highlight-current-row
                ref="tableThree"
                stripe
                size="small"
                @current-change="handleCurrentChange"
              >
                <el-table-column label="方案" width="120">
                  <template slot-scope="scope">
                    <el-radio v-model="form.planId" :label="scope.row.id">
                      <!-- 方案{{ scope.$index + 1 }} -->
                      {{ scope.row.planTitle }}
                    </el-radio>
                  </template>
                </el-table-column>
                <el-table-column label="保障项目">
                  <template
                    v-if="
                      id == '1001370' ||
                        id == '1001371' ||
                        id == '1001380' ||
                        id == '1001379'
                    "
                  >
                    <el-table-column
                      label="意外身故及伤残保障"
                      prop="death_quota"
                    >
                      <template slot-scope="scope"
                        >{{ scope.row.death_quota }}万元
                      </template>
                    </el-table-column>

                    <el-table-column
                      v-if="id == '1001370' || id == '1001380'"
                      label="意外医药补偿(每次意外事故最高限额,不限医保范围内的医疗费用，保障全额自费费用)"
                      prop="medical_quota"
                      width="230"
                      ><template slot-scope="scope"
                        >{{ scope.row.medical_quota }}万元
                      </template> </el-table-column
                    ><el-table-column
                      v-else
                      label="意外医药补偿(每次意外事故最高限额)"
                      prop="medical_quota"
                      width="230"
                    >
                      <template slot-scope="scope"
                        >{{ scope.row.medical_quota }}万元
                      </template>
                    </el-table-column>
                    <el-table-column label="每次事故免赔额">
                      100元
                    </el-table-column>
                    <el-table-column label="每次事故赔付比例">
                      最大100%
                    </el-table-column>
                    <el-table-column
                      label="意外每日住院津贴(每一保险年度总赔偿日数以180天为限)"
                      prop="hospital_allowance"
                    >
                      <template slot-scope="scope"
                        >{{ scope.row.hospital_allowance }}/天
                      </template>
                    </el-table-column>
                    <el-table-column label="每次住院免责天数">
                      3天
                    </el-table-column>
                  </template>
                  <template v-else>
                    <el-table-column
                      label="身故及伤残保障(万元)"
                      prop="death_quota"
                    ></el-table-column>
                    <el-table-column
                      label="意外医药补偿(万元)"
                      prop="medical_quota"
                      width="230"
                    ></el-table-column>
                    <el-table-column
                      label="误工费用（元/天）"
                      prop="loss_work_cost"
                    ></el-table-column>
                    <el-table-column
                      label="住院津贴（元/天）"
                      prop="hospital_allowance"
                    ></el-table-column>
                    <el-table-column label="法律费用（元）" prop="legal_fees">
                    </el-table-column>
                  </template>
                </el-table-column>
              </el-table>
              <div class="checkThree">
                <el-checkbox
                  v-model="form.isAllDays"
                  v-if="isAllDays == 1"
                  true-label="1"
                  false-label="0"
                  @change="getProductPlanMoney"
                >
                  附加24小时
                  <!-- <el-popover
                    placement="top-start"
                    title="标题"
                    width="200"
                    trigger="hover"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                  >
                    <i
                      class="el-icon-question"
                      slot="reference"
                      style="color:#4F8BF0"
                    >
                    </i>
                  </el-popover> -->
                </el-checkbox>
                <el-radio-group
                  v-model="form.disabRatio"
                  @change="getProductPlanMoney"
                >
                  <el-radio
                    label="is_one_percent"
                    v-if="disaRatio.is_one_percent == 1"
                  >
                    十级伤残，1%
                    <!-- <el-popover
                      placement="top-start"
                      title="标题"
                      width="200"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <i
                        class="el-icon-question"
                        slot="reference"
                        style="color:#4F8BF0"
                      >
                      </i>
                    </el-popover> -->
                  </el-radio>
                  <el-radio
                    label="is_three_percent"
                    v-if="disaRatio.is_three_percent == 1"
                  >
                    十级伤残，3%
                    <!-- <el-popover
                      placement="top-start"
                      title="标题"
                      width="200"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <i
                        class="el-icon-question"
                        slot="reference"
                        style="color:#4F8BF0"
                      >
                      </i>
                    </el-popover> -->
                  </el-radio>
                  <el-radio
                    label="is_five_percent"
                    v-if="disaRatio.is_five_percent == 1"
                  >
                    十级伤残，5%
                    <!-- <el-popover
                      placement="top-start"
                      title="标题"
                      width="200"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <i
                        class="el-icon-question"
                        slot="reference"
                        style="color:#4F8BF0"
                      >
                      </i>
                    </el-popover> -->
                  </el-radio>
                  <el-radio
                    label="is_seven_percent"
                    v-if="disaRatio.is_seven_percent == 1"
                  >
                    十级伤残，7%
                    <!-- <el-popover
                      placement="top-start"
                      title="标题"
                      width="200"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <i
                        class="el-icon-question"
                        slot="reference"
                        style="color:#4F8BF0"
                      >
                      </i>
                    </el-popover> -->
                  </el-radio>
                  <el-radio
                    label="is_ten_percent"
                    v-if="disaRatio.is_ten_percent == 1"
                  >
                    十级伤残，10%
                    <!-- <el-popover
                      placement="top-start"
                      title="标题"
                      width="200"
                      trigger="hover"
                      content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                      <i
                        class="el-icon-question"
                        slot="reference"
                        style="color:#4F8BF0"
                      >
                      </i>
                    </el-popover> -->
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
          <div class="stapTit" :class="step4 ? '' : 'show'">
            <p>填写保障人员</p>
            <span @click="step4 = false" v-if="step4">
              收起 <i class="iconfont icon-shouqi"></i>
            </span>
            <span @click="step4 = true" v-else>
              展开 <i class="iconfont icon-zhankai"></i>
            </span>
          </div>
          <div class="setpContent four" v-show="step4">
            <div class="contentArea">
              <div class="btnbox">
                <el-button size="small" @click="dialogVisible = true"
                  >批量识别身份证</el-button
                >
                <el-button size="small" @click="down('/template/person.xlsx')">
                  下载人员模版
                </el-button>
                <el-upload
                  class="upload-demo"
                  action=""
                  accept=".xlsx,.xls,.csv"
                  :http-request="bulkImport"
                  :show-file-list="false"
                  multiple
                  style="display:inline-block;margin:0 10px;"
                >
                  <el-button size="small"> 上传人员模版</el-button>
                </el-upload>
                <el-button size="small" @click="emptyPersonList">
                  清空
                </el-button>
              </div>
              <div class="tablebox">
                <el-table
                  :data="form.personList"
                  row-key="$index"
                  border
                  ref="crewTable"
                  style="width:100%;margin: 20px 0 0;"
                  id="crewTable"
                  empty-text=" "
                >
                  <el-table-column type="index" label="序号" width="80">
                  </el-table-column>
                  <el-table-column prop="idCardType" label="证件类型">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'personList.' + scope.$index + '.idCardType'"
                        :rules="rules.idCardType"
                      >
                        <el-select
                          v-model="scope.row.idCardType"
                          placeholder="点击选择证件类型"
                          size="mini"
                        >
                          <el-option label="身份证" value="1"></el-option>
                          <!-- <el-option label="护照" value="beijing"></el-option> -->
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="姓名">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'personList.' + scope.$index + '.name'"
                        :rules="rules.name"
                      >
                        <el-input
                          v-model="scope.row.name"
                          size="mini"
                          placeholder="请输入内容"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="idCardNum" label="证件号">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'personList.' + scope.$index + '.idCardNum'"
                        :rules="rules.idCardNum"
                      >
                        <el-input
                          v-model.trim="scope.row.idCardNum"
                          size="mini"
                          placeholder="请输入内容"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="保费（元）">
                    <template>
                      {{ unitPrice }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleCrew(scope.$index)"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-form-item prop="personList"> </el-form-item>
              </div>
              <el-button size="small" @click="addCrew">
                <i class="el-icon-circle-plus-outline"></i> 添加人员
              </el-button>
            </div>
          </div>
          <div
            class="stapTit"
            :class="step5 ? '' : 'show'"
            v-if="detailsData.isBill == 1"
          >
            <p>填写发票信息</p>
            <span @click="step5 = false" v-if="step5">
              收起 <i class="iconfont icon-shouqi"></i>
            </span>
            <span @click="step5 = true" v-else>
              展开 <i class="iconfont icon-zhankai"></i>
            </span>
          </div>
          <div class="setpContent five">
            <div class="contentArea" v-show="step5">
              <template v-if="detailsData.isBill == 1">
                <div class="hint">
                  <p>
                    <i class="el-icon-warning-outline"></i>
                    增值税电子普通发票的法律效力、基本用途、基本使用规定等与税务局监制的增值税普通发票相同
                  </p>
                </div>
                <el-form-item label="是否开票：" prop="isHaveBill">
                  <el-radio-group v-model="form.isHaveBill">
                    <el-radio label="0">否</el-radio>
                    <el-radio label="1">是</el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="form.isHaveBill == 1">
                  <el-form-item label="选择发票类型：" prop="invoiceType">
                    <el-radio-group
                      v-model="form.invoiceType"
                      @change="changeTicket"
                    >
                      <el-radio label="1">增值税普通发票</el-radio>
                      <el-radio label="2" v-if="isSpecial == 1">
                        增值税专用发票
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <div class="flexbox">
                    <el-form-item label="纳税人名称：" prop="taxpayer_name">
                      <el-input v-model="form.taxpayer_name"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号：" prop="taxpayer_id">
                      <el-input v-model="form.taxpayer_id"></el-input>
                    </el-form-item>
                    <template v-if="form.invoiceType == 2">
                      <el-form-item
                        label="税务开户行名称："
                        prop="taxpayer_bank"
                      >
                        <el-input v-model="form.taxpayer_bank"></el-input>
                      </el-form-item>
                      <el-form-item
                        label="税务开户行账号："
                        prop="taxpayer_bankno"
                      >
                        <el-input v-model="form.taxpayer_bankno"></el-input>
                      </el-form-item>
                      <el-form-item
                        label="收件人姓名："
                        prop="new_contact_name"
                      >
                        <el-input v-model="form.new_contact_name"></el-input>
                      </el-form-item>
                      <el-form-item
                        label="收件人手机号码："
                        prop="invoice_phone"
                      >
                        <el-input v-model="form.invoice_phone"></el-input>
                      </el-form-item>
                      <el-form-item label="税务登记地址：" prop="taxpayer_addr">
                        <el-input v-model="form.taxpayer_addr"></el-input>
                      </el-form-item>
                      <el-form-item label="税务登记电话：" prop="taxpayer_tel">
                        <el-input v-model="form.taxpayer_tel"></el-input>
                      </el-form-item>
                      <el-form-item label="收件人地址：" prop="address">
                        <el-input v-model="form.address"></el-input>
                        <p style="font-size: 12px; color: #f56c6c;">
                          *因涉及后期纸质邮寄，请务必填写能联系的实际地址
                        </p>
                      </el-form-item>
                      <el-form-item label="一般纳税人证明：" prop="ext_info">
                        <el-upload
                          action="/api/upload/upload"
                          name="file"
                          multiple
                          accept="image/jpeg,image/gif,image/png"
                          :http-request="upload3"
                          :file-list="ext_infoList"
                          :on-remove="handleRemove3"
                          class="uploadLeft"
                        >
                          <el-button size="small" type="primary">
                            点击上传
                          </el-button>
                        </el-upload>
                        <p style="font-size: 12px; color: #f56c6c;">
                          一般纳税人资质查询：<a
                            href="http://www.800000361.com/gs/"
                            target="_blank"
                          >
                            点击查询
                          </a>
                        </p>
                      </el-form-item>
                    </template>
                  </div>
                </template>
              </template>
              <div class="check" @click="isClauseBox">
                <el-checkbox v-model="is_deal">
                  <span style="font-weight: bold;" v-if="id == '100002'">
                    本保单投保（含批改）5类职业类别的人员数量须不高于总投保（含批改）人数的25%，否则，须向保险公司申请并获同意后，方可投保（含批改）及生效。<br />
                  </span>
                  <span style="font-weight: bold;" v-if="id == '100003'">
                    本保单投保（含批改）5-6类职业类别的人员数量须不高于总投保（含批改）人数的25%，否则，须向保险公司申请并获同意后，方可投保（含批改）及生效。<br />
                  </span>
                </el-checkbox>
                <template
                  v-if="
                    id == '1001370' ||
                      id == '1001371' ||
                      id == '1001380' ||
                      id == '1001379'
                  "
                >
                  <span style="font-weight: bold;">
                    重要提示<br />尊敬的客户，您即将进入美亚财产保险的产品投保流程<br />
                  </span>
                  <span
                    >请在完成投保之前仔细阅读保险条款、投保须知、客户告知书等内容并关注承保保险公司信息。
                    为了维护您的权益，我们将会安全记录您的操作。</span
                  >
                </template>
                <template v-else>
                  我已全面阅读并理解了
                  <!-- 投保须知 -->
                  <span
                    v-for="(item, index) in detailsData.insuranceNotice"
                    :key="index"
                  >
                    《{{ item.name }}》、
                  </span>
                  <!-- 保险条款 -->
                  <span
                    v-for="(item, index) in detailsData.insureClause"
                    :key="index + 'insure'"
                  >
                    《{{ item.name }}》、
                  </span>
                  及其中有关减免保险责任的相关内容
                </template>
              </div>
            </div>
            <div class="bottomBtn">
              <div class="text">
                <p>
                  总人数：<span>{{ form.personList.length }}</span>
                </p>
                <p>
                  保费总价：<span> ￥{{ totalPrice }} </span>
                </p>
              </div>
              <div class="btn" @click="createOrder">
                立即投保
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <v-foot
      :id="detailsData.agent_id"
      :tit="detailsData.agent_name"
      type="1"
      v-if="detailsData"
    ></v-foot>
    <!-- 身份证识别 -->
    <el-dialog
      title="身份证批量识别"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <identification
        :visible.sync="dialogVisible"
        @change="identification"
        v-if="dialogVisible"
      ></identification>
    </el-dialog>
    <!-- 阅读条款弹窗 -->
    <el-dialog
      top="calc(100vh - 700px)"
      :visible.sync="isClauseBoxVisible"
      :show-close="false"
      width="1200px"
      :append-to-body="false"
      class="clauseBox"
    >
      <p class="hint">
        <i class="el-icon-warning-outline"></i>
        为保障您的合法权益，请逐页阅读以上文件，再点击知晓并同意!
      </p>
      <div class="rollBox">
        <el-checkbox-group v-model="checkReadList">
          <!-- 投保须知 -->
          <div
            class="item"
            v-for="(item, index) in detailsData.insuranceNotice"
            :key="index"
            @click="pushUrl(item.url)"
            ref="rollItem"
          >
            <el-checkbox :label="item.url">《{{ item.name }}》</el-checkbox>
          </div>
          <!-- 保险条款 -->
          <div
            class="item"
            v-for="(item, index) in detailsData.insureClause"
            :key="index + 'insure'"
            @click="pushUrl(item.url)"
            ref="rollItem"
          >
            <el-checkbox :label="item.url">《{{ item.name }}》</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <div style="height:400px;">
        <iframe
          :key="ReadUrl"
          :src="ReadUrl"
          width="100%"
          height="400px"
          v-if="isClauseBoxVisible"
        ></iframe>
      </div>
      <el-button
        @click="rollLength == checkReadList.length ? consentBtn() : ''"
        :class="rollLength == checkReadList.length ? 'active' : ''"
      >
        我已知晓并同意
      </el-button>
    </el-dialog>
    <!-- 电子签章提示 -->
    <el-dialog
      top="calc(100vh - 700px)"
      title="认证电子签"
      :visible.sync="ishint"
      :show-close="false"
      width="360px"
      :append-to-body="false"
      class="ishintBox"
    >
      <div class="hintBox">
        <img src="@/assets/images/product/authorization.png" alt="" />
        <p>进行<span>认证</span>后，</p>
        <p>此企业投保或批改时<span>不需要</span>进行<span>线下盖章</span>。</p>
        <el-button @click="goApprove" type="primary" size="small">
          去认证
        </el-button>
      </div>
    </el-dialog>
    <!-- 电子签章去认证 -->
    <el-dialog
      top="calc(100vh - 700px)"
      title="认证电子签"
      :visible.sync="isApply"
      :show-close="false"
      width="380px"
      :append-to-body="false"
      class="isApplybox"
    >
      <div class="applyBox">
        <img src="@/assets/images/product/applyboxtop.png" alt="" />
        <p class="tit">企业未认证</p>
        <p>
          <span>认证后</span>投保、批改都<span>不需要</span>提供<span
            >盖章件</span
          >
        </p>
        <el-button @click="goApprove" type="primary" size="small">
          去认证
        </el-button>
        <el-button @click="isApply = false" size="small">
          暂不申请
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import vHead from "@/components/vhead";
import vFoot from "@/components/vFoot";
import { upload, businessLicenseIdentification } from "@/api/public";
import { getIsContract } from "@/api/signature";
import {
  getProductTimeRule,
  getWorkType,
  getWork,
  getProductPlan,
  getProductPlanMoney,
  createOrder,
  getAreaList,
  getPersonList,
  getPolicyHolder,
  getProductDetail,
  getInsuredList,
  getApplicationList
} from "@/api/insure";
import {
  getOrderInsured,
  getOrderInvoice,
  getOrderPersonnel
} from "@/api/guarantee";
import compressImg from "@/utils/compressImg";
import verify from "@/utils/verify";
import identification from "@/components/common/identification";
import download from "@/utils/download";
export default {
  name: "oneFillIn",
  components: {
    vHead,
    vFoot,
    identification
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    numId: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    var isId = (rule, value, callback) => {
      let val = verify.idNoFormatCheck(value);
      let age = verify.getAge(value);
      if (!val) {
        return callback(new Error("身份证号码不正确"));
      } else if (age > this.endAge || age < this.startAge) {
        return callback(new Error("年龄超限"));
      } else {
        let i = 0;
        this.form.personList.forEach(element => {
          if (element.idCardNum == value) {
            i++;
          }
        });
        if (i > 1) {
          return callback(new Error("身份证号码重复"));
        } else {
          callback();
        }
      }
    };
    var isId2 = (rule, value, callback) => {
      let val = verify.idNoFormatCheck(value);
      if (!val) {
        return callback(new Error("身份证号码不正确"));
      } else {
        callback();
      }
    };
    return {
      applicationList: [], //获取常用投保人
      insuredList: [], //获取常用被保人接口
      contacts: "", //投保常用联系人
      contacts2: "", //被保常用联系人
      detailsData: "", //产品详情信息
      isPolicyHolder: "0", //是否固定投保人
      policyMoney: "0.00", //保费单价
      premiumRule: "", //保费精准位数
      premiumSetting: "", //保费计算规则
      isSpecial: "", //是否支持开专票
      specialTicket: "0", //专票最低开具金额
      plan: [], //方案信息
      form: {
        applicationName: "", //投保人名称
        applicationCode: "", //投保人编码,
        applicationAddress: "", //投保人详细地址
        applicationPhone: "", //投保人联系方式
        applicationCodeImg: "", //投保人证件图片
        applicationLegalPerson: "", //投保人负责人
        applicationLeagronCard: "", //投保人身份证
        applicationMailbox: "", //投保人邮箱
        applicationPCA: [], //投保地区
        businessSite: "", //  投保人营业范围
        insuredName: "", //被保人名称
        insuredLeagronCard: "", //被保人身份证
        insuredMailbox: "", //被保人邮箱
        insuredCode: "", //被保人编码
        insuredAddress: "", //被保人详细地址
        insuredPhone: "", //被保人联系方式
        insuredCodeImg: "", //被保人证件图片
        insuredLegalPerson: "", //被保人负责人
        insuredPCA: [], //投保地区
        insuredBusinessSite: "", //  被保人营业范围
        shigongdidian:"",
        sTime: "", //生效日期
        workType: "", //职业类别 id数组
        same: 1, //投保被保是否相同 1相同 0不同
        planId: "", //方案id
        disabRatio: "", //伤残比例
        isAllDays: "0", //是否扩展24小时
        guaranteePeriod: "", //投保期限
        workId: [], //工种id
        personList: [], //人员列表
        isHaveBill: "1", //是否开票： 0 否 1 是
        invoiceType: "1", //发票类别：1 普票 2 专票
        taxpayer_name: "", //纳税人名称
        taxpayer_id: "", //纳税人识别号
        taxpayer_addr: "", //税务登记地址
        taxpayer_tel: "", //税务登记电话
        taxpayer_bank: "", //税务开户行名称
        taxpayer_bankno: "", //税务开户行账号
        ext_info: "", //纳税人证明 文件地址
        invoice_phone: "", //专票收件人手机号
        address: "", //专票收件人地址
        new_contact_name: "" //专票收件人名称
      },
      rules: {
        // applicationLeagronCard: [
        //   { required: true, message: "身份证号不能为空", trigger: "blur" },
        //   { validator: isId2, trigger: ["blur", "change"] }
        // ],
        // insuredLeagronCard: [
        //   { required: true, message: "身份证号不能为空", trigger: "blur" },
        //   { validator: isId2, trigger: ["blur", "change"] }
        // ],
        isHaveBill: [
          { required: true, message: "是否开票不能为空", trigger: "blur" }
        ],
        invoiceType: [
          { required: true, message: "发票类别不能为空", trigger: "blur" }
        ],
        taxpayer_name: [
          { required: true, message: "纳税人名称不能为空", trigger: "blur" }
        ],
        taxpayer_id: [
          { required: true, message: "纳税人识别号不能为空", trigger: "blur" }
        ],
        taxpayer_addr: [
          { required: true, message: "税务登记地址不能为空", trigger: "blur" }
        ],
        taxpayer_tel: [
          { required: true, message: "税务登记电话不能为空", trigger: "blur" }
        ],
        taxpayer_bank: [
          { required: true, message: "税务开户行名称不能为空", trigger: "blur" }
        ],
        taxpayer_bankno: [
          {
            required: true,
            message: "税务开户行账号不能为空",
            trigger: "blur"
          }
        ],
        ext_info: [
          { required: true, message: "纳税人证明不能为空", trigger: "blur" }
        ],
        invoice_phone: [
          { required: true, message: "收件人手机号不能为空", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "收件人手机号格式不正确",
            trigger: "blur"
          }
        ],
        new_contact_name: [
          { required: true, message: "收件人名称不能为空", trigger: "blur" }
        ],
        address: [
          {
            required: true,
            message: "专票收件人地址不能为空",
            trigger: ["blur", "change"]
          }
        ],
        applicationName: [
          {
            required: true,
            message: "营业执照名称不能为空",
            trigger: ["blur", "change"]
          }
        ],
        applicationCode: [
          {
            required: true,
            message: "统一信用代码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!verify.isBusiness(value)) {
                callback(new Error("信用代码不正确"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        applicationAddress: [
          {
            required: true,
            message: "经营地址不能为空",
            trigger: ["blur", "change"]
          }
        ],
        shigongdidian: [
          {
            required: true,
            message: "施工地点不能为空",
            trigger: ["blur", "change"]
          }
        ],
        applicationPhone: [
          {
            required: true,
            message: "手机号码不能为空",
            trigger: ["blur", "change"]
          },
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号格式不正确",
            trigger: ["blur", "change"]
          }
        ],
        applicationCodeImg: [
          {
            required: true,
            message: "营业执照图片不能为空",
            trigger: ["blur", "change"]
          }
        ],
        applicationLegalPerson: [
          {
            required: true,
            message: "法人不能为空",
            trigger: ["blur", "change"]
          }
        ],
        applicationPCA: [
          {
            required: true,
            message: "地区不能为空",
            trigger: ["blur", "change"]
          }
        ],
        insuredPCA: [
          {
            required: true,
            message: "地区不能为空",
            trigger: ["blur", "change"]
          }
        ],
        insuredName: [
          {
            required: true,
            message: "营业执照名称不能为空",
            trigger: ["blur", "change"]
          }
        ],
        insuredCode: [
          {
            required: true,
            message: "统一信用代码不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (!verify.isBusiness(value)) {
                callback(new Error("信用代码不正确"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        insuredAddress: [
          {
            required: true,
            message: "经营地址不能为空",
            trigger: ["blur", "change"]
          }
        ],
        insuredPhone: [
          {
            required: true,
            message: "手机号码不能为空",
            trigger: ["blur", "change"]
          },
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        insuredCodeImg: [
          {
            required: true,
            message: "营业执照图片不能为空",
            trigger: ["blur", "change"]
          }
        ],
        insuredLegalPerson: [
          {
            required: true,
            message: "法人不能为空",
            trigger: ["blur", "change"]
          }
        ],
        sTime: [
          {
            required: true,
            message: "生效日期不能为空",
            trigger: ["blur", "change"]
          }
        ],
        personList: [
          {
            required: true,
            message: "人员清单不能为空",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback();
              } else {
                callback(new Error("姓名只可以是中文!"));
              }
            },
            trigger: "blur"
          }
        ],
        idCardNum: [
          { required: true, message: "证件号不能为空", trigger: "blur" },
          { validator: isId, trigger: ["blur", "change"] }
        ],
        planId: [
          {
            required: true,
            message: "方案不能为空",
            trigger: ["blur", "change"]
          }
        ],
        disabRatio: [
          {
            required: true,
            message: "伤残比例不能为空",
            trigger: ["blur", "change"]
          }
        ],
        guaranteePeriod: [
          {
            required: true,
            message: "投保期限不能为空",
            trigger: ["blur", "change"]
          }
        ],
        workType: [
          {
            required: true,
            message: "职业类别不能为空",
            trigger: ["blur", "change"]
          }
        ],
        workId: [
          {
            required: true,
            message: "职业不能为空",
            trigger: ["blur", "change"]
          }
        ]
      },
      oneList: [],
      twoList: [],
      regionArray: [], //地区数组
      ext_infoList: [], //纳税人证明 文件地址数组
      // 设置时间
      pickerOptions: {
        disabledDate: time => {
          let _startTime = new Date(
            this.startTime.split("-").join("/")
          ).getTime();
          let _endTime = new Date(this.endTime.split("-").join("/")).getTime();
          return time.getTime() < _startTime || time.getTime() > _endTime;
        }
      },
      dialogVisible: false, // 身份证识别弹窗
      monthArray: [], // 保障期限选项
      startTime: "", // 起保日期
      endTime: "", // 终止日期
      workTypeArray: [], // 职业类别数组
      optionsArray: [], // 工种
      isAllDays: 0, // 是否有扩展24小时
      disaRatio: {}, // 是否伤残比例
      startAge: 0, // 起保最小年龄
      endAge: 0, // 起保最大年龄
      insureNum: 0, //起保人数
      // plan: [], //方案
      cascaderKey: 1, //解决切换职业类别报错
      is_deal: false, //是否同意协议 false true
      step1: true, //五个步骤展开收起控制
      step2: true, //五个步骤展开收起控制
      step3: true, //五个步骤展开收起控制
      step4: true, //五个步骤展开收起控制
      step5: true, //五个步骤展开收起控制
      isClauseBoxVisible: false, // 阅读条款弹窗
      checkReadList: [], // 阅读条款 已阅读项
      rollLength: "", // 阅读条款  有几个条款
      ReadUrl: "", // 阅读条款 url
      NoFollow: false, //是否需要电子签章
      certification: false, //是否已经认证
      disabledName: true, //电子签章联系人是否可以修改
      disabledPhone: true, //电子签章联系人电话是否可以修改
      ishint: false, //电子签章认证提示弹窗
      isApply: false //电子签章认证状态弹窗
    };
  },
  mounted() {
    console.log(this.id);
    //获取方案详情信息
    this.getProductDetail();
    // 获取保障期限、起保日期
    this.getProductTimeRule();
    // 获取职业类别
    this.getWorkType();
    // 获取产品方案
    this.getProductPlan();
    // 获取地区库
    this.getAreaList();
    // 获取是否固定投保人
    this.getPolicyHolder();
    // 获取常用投保人接口
    this.getApplicationList();
    // 获取常用被保人接口
    this.getInsuredList();
    // 页面切换判断电子签是否已认证
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        console.log("页面显示");
        //请求电子签章是否已经认证或是否允许
        this.getIsContract();
      }
    });
    //判断是否是驳回页转跳过来的
    if (this.numId) {
      var that = this;
      setTimeout(() => {
        that.getOrderInsured();
        that.getOrderInvoice();
        that.getOrderPersonnel();
      }, 1000);
    }
  },
  methods: {
    upload(e) {
      this.changeBusiness(e, 1);
    },
    upload2(e) {
      this.changeBusiness(e, 2);
    },
    upload3(e) {
      var that = this;
      let form = new FormData();
      compressImg(e.file).then(function(e) {
        form.append("file", e);
        form.append("folder", "BusinessLicense");
        upload(form)
          .then(function(res) {
            console.log(res);
            if (res.code == 1) {
              let _data = { name: res.data.fileName, url: res.data.fileUrl };
              that.ext_infoList = [];
              that.ext_infoList.push(_data);
              that.form.ext_info = res.data.fileUrl;
              that.triggerVerify("ext_info");
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      });
    },
    // 删除上传营业执照
    handleRemove1(file, fileList) {
      console.log(file, fileList);
      this.oneList = [];
      this.form.applicationCodeImg = "";
    },
    // 删除上传营业执照
    handleRemove2(file, fileList) {
      console.log(file, fileList);
      this.twoList = [];
      this.form.insuredCodeImg = "";
    },
    // 删除一般证明
    handleRemove3(file, fileList) {
      console.log(file, fileList);
      console.log(this.ext_infoList);
      this.ext_infoList = [];
      this.form.ext_info = "";
    },
    // 被保企业和投保企业相同选项触发
    changeSame(e) {
      console.log(e);
      if (e == 1) {
        this.form.insuredName = this.form.applicationName;
        this.form.insuredCode = this.form.applicationCode;
        this.form.insuredAddress = this.form.applicationAddress;
        this.form.insuredPhone = this.form.applicationPhone;
        this.form.insuredCodeImg = this.form.applicationCodeImg;
        this.form.insuredLegalPerson = this.form.applicationLegalPerson;
        this.form.insuredBusinessSite = this.form.businessSite;
        this.form.insuredPCA = this.form.applicationPCA;
        this.form.insuredBusinessSite = this.form.businessSite;
        this.twoList = this.oneList;
      }
    },
    // 批量上传返回数据
    identification(e) {
      console.log(e);
      if (e.length > 0) {
        e.forEach(element => {
          let _data = { idCardType: "1" };
          _data.name = element.name;
          _data.idCardNum = element.idCardNum;
          this.form.personList.push(_data);
        });
      }
      this.$refs.form.validateField("personList");
      // 请求保费
      this.getProductPlanMoney();
    },
    // 模板下载
    down(downurl) {
      download(downurl);
    },
    // 模板上传
    bulkImport(e) {
      let that = this;
      let _form = new FormData();
      console.log(e);
      _form.append("file", e.file);
      _form.append("folder", "other");
      console.log(_form.get("file"));
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      upload(_form)
        .then(function(e) {
          console.log(e);
          if (e.code == 1) {
            getPersonList({ fileUrl: e.data.fileUrl }).then(function(res) {
              console.log(res);
              loadind.close();
              if (res.code == 1) {
                if (res.data.fileData.length > 0) {
                  res.data.fileData.forEach(element => {
                    let _data = { idCardType: element[2] + "" };
                    _data.name = element[0];
                    _data.idCardNum = element[1];
                    if (element[2]) {
                      _data.idCardType = element[2] + "";
                    } else {
                      _data.idCardType = "1";
                    }
                    that.form.personList.push(_data);
                  });
                  // 触发验证
                  that.$nextTick(function() {
                    let crewTable = document.getElementById("crewTable");
                    var evt = document.createEvent("HTMLEvents");
                    evt.initEvent("blur", false, false);
                    var elem = crewTable.getElementsByTagName("input");
                    elem.forEach(element => {
                      element.dispatchEvent(evt);
                    });
                    that.$refs.form.validateField("personList");
                  });
                  // 请求保费
                  that.getProductPlanMoney();
                }
              } else {
                that.$message.error(res.msg);
              }
            });
          } else {
            that.$message.error(e.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 清空全部人员
    emptyPersonList() {
      this.form.personList = [];
    },
    // 删除人员
    deleCrew(e) {
      let that = this;
      this.form.personList.splice(e, 1);
      // 触发验证
      that.$nextTick(function() {
        let crewTable = document.getElementById("crewTable");
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("blur", false, false);
        var elem = crewTable.getElementsByTagName("input");
        elem.forEach(element => {
          element.dispatchEvent(evt);
        });
      });
      this.getProductPlanMoney();
    },
    // 添加人员
    addCrew() {
      let _index = this.form.personList.length - 1;
      if (_index >= 0) {
        this.$refs.form.validateField(
          "personList." + [_index] + ".name",
          error => {
            if (error) {
              this.$message.error(error);
            } else {
              this.$refs.form.validateField(
                "personList." + [_index] + ".idCardNum",
                error => {
                  if (error) {
                    this.$message.error(error);
                  } else {
                    this.form.personList.push({
                      idCardNum: "",
                      name: "",
                      idCardType: "1"
                    });
                    this.getProductPlanMoney();
                  }
                }
              );
            }
          }
        );
      } else {
        this.form.personList.push({
          idCardNum: "",
          name: "",
          idCardType: "1"
        });
        this.getProductPlanMoney();
      }
      this.$refs.form.validateField("personList");
    },
    // 是否开票切换触发// 营业执照名称  统一信用代码 变化触发
    changeBill(e) {
      console.log(e);
      if (this.form.applicationName != "") {
        this.form.taxpayer_name = this.form.applicationName;
      }
      if (this.form.applicationCode != "") {
        this.form.taxpayer_id = this.form.applicationCode;
        this.getIsContract(); //请求电子签章是否已经认证或是否允许
      }
      // if (this.form.applicationCodeImg != "") {
      //   this.form.ext_info = this.form.applicationCodeImg;
      //   this.ext_infoList = this.oneList;
      // }
    },
    // 是否专票切换触发
    changeTicket(e) {
      console.log(e);
      if (e == 2) {
        if (parseFloat(this.specialTicket) > parseFloat(this.totalPrice)) {
          this.form.invoiceType = "1";
          this.$message.warning(
            "本产品总保费要大于" +
              this.specialTicket +
              "，才可以开增值税专用发票 "
          );
        }
      }
    },
    // 上传营业执照处理
    changeBusiness(e, num) {
      console.log(e, num);
      var that = this;
      let form = new FormData();
      console.log(e);
      compressImg(e.file).then(function(e) {
        form.append("file", e);
        form.append("folder", "BusinessLicense");

        console.log(e);
        upload(form).then(function(e) {
          console.log(e);
          let _data = { name: e.data.fileName, url: e.data.fileUrl };
          if (num == 1) {
            that.oneList = [];
            that.oneList.push(_data);
            that.form.applicationCodeImg = e.data.fileUrl;
            that.triggerVerify("applicationCodeImg");
          } else {
            that.twoList = [];
            that.twoList.push(_data);
            that.form.insuredCodeImg = e.data.fileUrl;
            that.triggerVerify("insuredCodeImg");
          }
          businessLicenseIdentification({ businessLicense: e.data.fileUrl })
            .then(function(res) {
              console.log(res);
              if (res.code == 1) {
                if (num == 1) {
                  that.form.applicationCode =
                    res.data.words_result["社会信用代码"].words;
                  that.form.applicationLegalPerson =
                    res.data.words_result["法人"].words;
                  that.form.applicationName =
                    res.data.words_result["单位名称"].words;
                  that.form.applicationAddress =
                    res.data.words_result["地址"].words;
                  that.form.businessSite =
                    res.data.words_result["经营范围"].words;
                } else {
                  that.form.insuredCode =
                    res.data.words_result["社会信用代码"].words;
                  that.form.insuredLegalPerson =
                    res.data.words_result["法人"].words;
                  that.form.insuredName =
                    res.data.words_result["单位名称"].words;
                  that.form.insuredAddress =
                    res.data.words_result["地址"].words;
                  that.form.insuredBusinessSite =
                    res.data.words_result["经营范围"].words;
                }
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        });
      });
    },
    // 获取是否固定投保人
    getPolicyHolder() {
      let that = this;
      let _data = {
        productId: this.id
      };
      getPolicyHolder(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            if (res.data.isAppointAapplication == 1) {
              that.isPolicyHolder = 1;
              that.oneList = [
                { name: "营业执照", url: res.data.applicationCodeImg[0].url }
              ];
              that.form.applicationName = res.data.applicationName; //投保人名称
              that.form.applicationCode = res.data.applicationCode; //投保人编码,
              that.form.applicationAddress = res.data.applicationAddress; //投保人详细地址
              that.form.applicationPhone = res.data.applicationPhone; //投保人联系方式
              that.form.applicationCodeImg = res.data.applicationCodeImg[0].url; //投保人证件图片
              that.form.applicationLegalPerson =
                res.data.applicationLegalPerson; //投保人负责人
              that.form.applicationPCA = []; //投保地区
              that.form.applicationPCA.push(
                parseInt(res.data.applicationProvince)
              );
              that.form.applicationPCA.push(parseInt(res.data.applicationCity));
              that.form.applicationPCA.push(parseInt(res.data.applicationArea));
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 保障期限、起保日期
    getProductTimeRule() {
      let that = this;
      let _data = {
        product_id: this.id,
        identification: 1
      };
      getProductTimeRule(_data)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.monthArray = res.data.month;
            that.form.guaranteePeriod = res.data.month[0];
            that.startTime = res.data.startTime;
            that.form.sTime = res.data.startTime; //设置默认时间
            that.endTime = res.data.endTime;
            that.premiumSetting = res.data.premiumSetting;
            that.premiumRule = res.data.premiumRule;
            that.isSpecial = res.data.isSpecial;
            that.specialTicket = res.data.specialTicket;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取职业类别
    getWorkType() {
      let that = this;
      getWorkType({ product_id: this.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.workTypeArray = res.data;
            that.form.workType = res.data[0].ids.join("-");
            that.getWork();
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取工种
    getWork() {
      let that = this;
      let _workCateIds = this.form.workType.split("-");
      getWork({ workCateIds: _workCateIds })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.optionsArray = res.data;
            if (res.data[0].id) {
              that.cascaderKey++;
              that.form.workId = [];
              that.form.workId.push(res.data[0].id);
              that.form.workId.push(res.data[0].child[0].id);
              that.form.workId.push(res.data[0].child[0].child[0].id);
              that.form.workId.push(res.data[0].child[0].child[0].child[0].id);
              that.getProductPlanMoney();
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取方案
    getProductPlan() {
      let that = this;
      getProductPlan({ product_id: this.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.plan = res.data.plan;
            that.form.planId = res.data.plan[0].id; //设置默认选中方案
            that.isAllDays = res.data.isAllDays;
            that.disaRatio = res.data.disaRatio;
            that.startAge = res.data.insureAge.startAge; // 起保最大年龄
            that.endAge = res.data.insureAge.endAge; // 起保最小年龄
            that.insureNum = res.data.insureNum; // 起保人数
            if (that.disaRatio.is_five_percent == 1) {
              that.form.disabRatio = "is_five_percent";
            } else if (that.disaRatio.is_one_percent == 1) {
              that.form.disabRatio = "is_one_percent";
            } else if (that.disaRatio.is_ten_percent == 1) {
              that.form.disabRatio = "is_ten_percent";
            } else if (that.disaRatio.is_three_percent == 1) {
              that.form.disabRatio = "is_three_percent";
            } else if (that.disaRatio.is_seven_percent == 1) {
              that.form.disabRatio = "is_seven_percent";
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 职业类别变化时触发获取工种
    changeWorkCateIds(e) {
      console.log(e);
      this.getWork();
    },
    // 获取保费
    getProductPlanMoney() {
      let that = this;
      let _workCateIds = this.form.workType.split("-");
      let _data = {
        product_id: that.id,
        planId: that.form.planId,
        disabRatio: that.form.disabRatio,
        isAllDays: that.form.isAllDays,
        guaranteePeriod: that.form.guaranteePeriod,
        workType: _workCateIds,
        workId: that.form.workId,
        insureNum: that.form.personList.length
      };
      console.log(that.form.workId);
      if (
        //保障期限/职业类别/职业不为空时请求保费
        that.form.workId.length > 0 &&
        that.form.workType &&
        that.form.guaranteePeriod
      ) {
        getProductPlanMoney(_data)
          .then(function(res) {
            console.log(res);
            if (res.code == 1) {
              that.$set(
                that.$refs.crewTable.store.states,
                "lazyTreeNodeMap",
                {}
              ); //清除表格缓存更新最新价格
              that.policyMoney = res.data.policyMoney;
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    // 获取产品详情信息
    getProductDetail() {
      let that = this;
      getProductDetail({ product_id: that.id })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.detailsData = res.data;
            // 设置条款阅读第一条
            that.checkReadList = [];
            that.checkReadList.push(that.detailsData.insuranceNotice[0].url);
            that.ReadUrl = that.detailsData.insuranceNotice[0].url;
            that.detailsData.insureClause.push({
                url:"http://insure.ruilubao.cn/白鸽宝隐私政策.pdf",
                name:"白鸽宝隐私政策.pdf",
                status:"success",
                uid:"1",
            });
            // 设置title
            document.title = "投保--" + res.data.productName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 获取地区
    getAreaList() {
      let that = this;
      getAreaList()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.regionArray = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 投保
    createOrder() {
      let that = this;
      if (this.form.same == 1) {
        this.form.insuredName = this.form.applicationName;
        this.form.insuredCode = this.form.applicationCode;
        this.form.insuredAddress = this.form.applicationAddress;
        this.form.insuredPhone = this.form.applicationPhone;
        this.form.insuredCodeImg = this.form.applicationCodeImg;
        this.form.insuredLegalPerson = this.form.applicationLegalPerson;
        this.form.insuredPCA = this.form.applicationPCA;
        this.form.insuredBusinessSite = this.form.businessSite;
        this.form.insuredLeagronCard = this.form.applicationLeagronCard;
        this.twoList = this.oneList;
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (!this.is_deal) {
            that.$message.error("请确认已阅读协议");
            return false;
          }
          if (this.form.personList.length < that.insureNum) {
            that.$message.error("本方案" + that.insureNum + "人起保");
            return false;
          }
          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let _data = JSON.parse(JSON.stringify(this.form));
          let _workCateIds = this.form.workType.split("-"); //转换工种库格式
          _data.workType = _workCateIds;
          _data.product_id = this.id;
          _data.applicationProvince = this.form.applicationPCA[0];
          _data.applicationCity = this.form.applicationPCA[1];
          _data.applicationArea = this.form.applicationPCA[2];
          _data.insuredProvince = this.form.insuredPCA[0];
          _data.insuredCity = this.form.insuredPCA[1];
          _data.insuredArea = this.form.insuredPCA[2];
          console.log(this.form);
          console.log(_data);
          createOrder(_data)
            .then(function(res) {
              console.log(res);
              loadind.close();
              if (res.code == 1) {
                that.$message.success(res.msg);
                if (res.data.nextStep == 1) {
                  that.$router.push({
                    path: "/insure/pay",
                    query: { numId: res.data.num_id }
                  });
                } else if (res.data.nextStep == 11) {
                  that.$router.push({
                    path: "/insure/uploadData",
                    query: { numId: res.data.num_id }
                  });
                } else {
                  that.$router.push({
                    path: "/guarantee"
                  });
                }
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          that.$notification.error({
            title: "错误",
            message: "投保信息异常，请核对投保信息"
          });
          return false;
        }
      });
    },
    // 方案链接列表选中方案
    handleCurrentChange(currentRow) {
      this.form.planId = currentRow.id;
    },
    //获取常用投保人接口
    getApplicationList() {
      let that = this;
      getApplicationList()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.applicationList = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取常用被保人接口
    getInsuredList() {
      let that = this;
      getInsuredList()
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.insuredList = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //常用投保人切换
    commonSelect1(e) {
      console.log(e);
      this.form.applicationCode = this.applicationList[e].code;
      this.form.applicationLegalPerson = this.applicationList[e].legal_person;
      this.form.applicationName = this.applicationList[e].name;
      this.form.applicationAddress = this.applicationList[e].address;
      this.form.businessSite = this.applicationList[e].business_site;
      this.form.applicationCodeImg = this.applicationList[e].code_img;
      this.form.applicationPCA = [
        this.applicationList[e].province,
        this.applicationList[e].city,
        this.applicationList[e].area
      ];
      this.form.applicationPhone = this.applicationList[e].phone;
      let _data = {
        name: "投保人营业执照",
        url: this.applicationList[e].code_img
      };
      this.oneList = [];
      this.oneList.push(_data);
      this.triggerVerify(["applicationPCA", "applicationCodeImg"]);
      // 触发开票切换触发// 营业执照名称  统一信用代码 变化触发
      this.changeBill();
      // 如果有其他的信息，更新一下
        this.form.taxpayer_addr = this.applicationList[e].taxpayer_addr ? this.applicationList[e].taxpayer_addr : ''; //税务登记地址
        this.form.taxpayer_tel = this.applicationList[e].taxpayer_tel ? this.applicationList[e].taxpayer_tel : ''; //税务登记电话
        this.form.taxpayer_bank = this.applicationList[e].taxpayer_bank ? this.applicationList[e].taxpayer_bank : ''; //税务开户行名称
        this.form.taxpayer_bankno = this.applicationList[e].taxpayer_bankno ? this.applicationList[e].taxpayer_bankno : ''; //税务开户行账号
        this.form.ext_info = this.applicationList[e].ext_info ? this.applicationList[e].ext_info : ''; //纳税人证明 文件地址
        this.form.invoice_phone = this.applicationList[e].invoice_phone ? this.applicationList[e].invoice_phone : ''; //专票收件人手机号
        this.form.address = this.applicationList[e].address ? this.applicationList[e].address : ''; //专票收件人地址
        this.form.new_contact_name = this.applicationList[e].new_contact_name ? this.applicationList[e].new_contact_name : ''; //专票收件人名称
    },
    //常用被保人切换
    commonSelect2(e) {
      console.log(e);
      this.form.insuredCode = this.insuredList[e].code;
      this.form.insuredLegalPerson = this.insuredList[e].legal_person;
      this.form.insuredName = this.insuredList[e].name;
      this.form.insuredAddress = this.insuredList[e].address;
      this.form.insuredCodeImg = this.insuredList[e].code_img;
      this.form.insuredPCA = [
        this.insuredList[e].province,
        this.insuredList[e].city,
        this.insuredList[e].area
      ];
      this.form.insuredBusinessSite = this.insuredList[e].business_site;
      this.form.insuredPhone = this.applicationList[e].phone;
      let _data = { name: "被保人营业执照", url: this.insuredList[e].code_img };
      this.twoList = [];
      this.twoList.push(_data);
      this.triggerVerify(["insuredPCA", "insuredCodeImg"]);
    },
    // 手动触发验证字段
    triggerVerify(field) {
      this.$nextTick(function() {
        this.$refs.form.validateField(field);
      });
    },
    // 打开条款弹窗
    isClauseBox(e) {
      console.log(e);
      this.isClauseBoxVisible = true;
      this.$nextTick(function() {
        this.rollLength = this.$refs.rollItem.length;
      });
    },
    // 切换阅读
    pushUrl(url) {
      if (!this.checkReadList.includes(url)) {
        this.checkReadList.push(url);
      }
      this.ReadUrl = url;
    },
    // 同意条款
    consentBtn() {
      this.isClauseBoxVisible = false; //关闭弹窗
      this.is_deal = true; //同意条款
    },
    // 电子签章
    // 去认证
    goApprove() {
      this.ishint = false; //提示弹窗
      this.isApply = false; //状态弹窗
      let _url = this.$router.resolve({
        path: "/signet/ident",
        query: { uid: this.$store.getters.id }
      });
      window.open(_url.href, "_blank");
    },
    // 判断是否需要电子签章，是否已经认证
    getIsContract() {
      let that = this;
      let _data = {
        proNum: this.detailsData.productCode,
        creditCode: this.form.applicationCode,
        uid: this.$store.getters.id
      };
      if (this.form.applicationCode && this.detailsData.productCode) {
        getIsContract(_data)
          .then(function(res) {
            console.log(res);
            if (res.code == 200) {
              if (res.data.isContract == 1) {
                that.NoFollow = true;
              } else {
                that.NoFollow = false;
              }
              if (res.data.isCertified == 1) {
                that.certification = true;
              } else {
                that.certification = false;
              }
              if (that.NoFollow & !that.certification) {
                that.isApply = true;
              }
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    //驳回重新录入
    //获取投、被保人
    getOrderInsured() {
      let that = this;
      getOrderInsured({ numId: this.numId, type: 3 })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            //投保人
            that.oneList = [
              { name: "营业执照", url: res.data.application.code_img }
            ];
            that.form.applicationName = res.data.application.name; //投保人名称
            that.form.applicationCode = res.data.application.code; //投保人编码,
            that.form.applicationAddress = res.data.application.address; //投保人详细地址
            that.form.applicationPhone = res.data.application.phone; //投保人联系方式
            that.form.applicationCodeImg = res.data.application.code_img; //投保人证件图片
            that.form.applicationLegalPerson =
              res.data.application.legal_person; //投保人负责人
            that.form.applicationPCA = []; //投保地区
            that.form.applicationPCA.push(
              parseInt(res.data.application.province)
            );
            that.form.applicationPCA.push(parseInt(res.data.application.city));
            that.form.applicationPCA.push(parseInt(res.data.application.area));
            //被保人
            that.twoList = [
              { name: "营业执照", url: res.data.insure.code_img }
            ];
            that.form.insuredName = res.data.insure.name; //投保人名称
            that.form.insuredCode = res.data.insure.code; //投保人编码,
            that.form.insuredAddress = res.data.insure.address; //投保人详细地址
            that.form.insuredPhone = res.data.insure.phone; //投保人联系方式
            that.form.insuredCodeImg = res.data.insure.code_img; //投保人证件图片
            that.form.insuredLegalPerson = res.data.insure.legal_person; //投保人负责人
            that.form.insuredPCA = []; //投保地区
            that.form.insuredPCA.push(parseInt(res.data.insure.province));
            that.form.insuredPCA.push(parseInt(res.data.insure.city));
            that.form.insuredPCA.push(parseInt(res.data.insure.area));
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取开票信息
    getOrderInvoice() {
      let that = this;
      getOrderInvoice({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            if (res.data.taxpayer_id) {
              that.form.invoiceType = res.data.type + ""; //发票类别：1 普票 2 专票
              that.form.taxpayer_name = res.data.taxpayer_name; //纳税人名称
              that.form.taxpayer_id = res.data.taxpayer_id; //纳税人识别号
              that.form.taxpayer_addr = res.data.taxpayer_addr; //税务登记地址
              that.form.taxpayer_tel = res.data.taxpayer_tel; //税务登记电话
              that.form.taxpayer_bank = res.data.taxpayer_bank; //税务开户行名称
              that.form.taxpayer_bankno = res.data.taxpayer_bankno; //税务开户行账号
              that.form.ext_info = res.data.ext_info; //纳税人证明 文件地址
              that.form.invoice_phone = res.data.invoice_phone; //专票收件人手机号
              that.form.address = res.data.address; //专票收件人地址
              that.form.new_contact_name = res.data.new_contact_name; //专票收件人名称
            } else {
              that.form.isHaveBill = "0";
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取保障人员
    getOrderPersonnel() {
      let that = this;
      getOrderPersonnel({ numId: this.numId, type: 3 })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            if (res.data.length > 0) {
              res.data.forEach(element => {
                let _data = { idCardType: "1" };
                _data.name = element.name;
                _data.idCardNum = element.code;
                that.form.personList.push(_data);
              });

              that.$refs.form.validateField("personList");
              // 请求保费
              that.getProductPlanMoney();
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  computed: {
    totalPrice() {
      let _Money = this.policyMoney * this.form.personList.length;
      console.log(this.premiumRule);
      console.log(this.premiumSetting);
      if (this.form.personList.length > 0) {
        if (this.premiumRule == 1) {
          return _Money.toFixed(this.premiumSetting);
        } else if (this.premiumRule == 2) {
          if (this.premiumSetting == 2) {
            _Money = Math.ceil(_Money * 100) / 100;
            return _Money.toFixed(2);
          } else {
            _Money = Math.ceil(_Money * 10000) / 10000;
            return _Money.toFixed(4);
          }
        } else {
          console.log(_Money);
          if (this.premiumSetting == 2) {
            return (Math.floor(_Money * 100) / 100).toFixed(
              this.premiumSetting
            );
          } else {
            return (Math.floor(_Money * 10000) / 10000).toFixed(
              this.premiumSetting
            );
          }
        }
      } else {
        return 0;
      }
    },
    unitPrice() {
      let _Money = this.policyMoney;
      if (this.form.personList.length > 0) {
        if (this.premiumRule == 1) {
          return _Money.toFixed(this.premiumSetting);
        } else if (this.premiumRule == 2) {
          if (this.premiumSetting == 2) {
            _Money = Math.ceil(_Money * 100) / 100;
            return _Money.toFixed(2);
          } else {
            _Money = Math.ceil(_Money * 10000) / 10000;
            return _Money.toFixed(4);
          }
        } else {
          console.log(_Money);
          if (this.premiumSetting == 2) {
            return (Math.floor(_Money * 100) / 100).toFixed(
              this.premiumSetting
            );
          } else {
            return (Math.floor(_Money * 10000) / 10000).toFixed(
              this.premiumSetting
            );
          }
        }
      } else {
        return 0;
      }
    }
  },
  watch: {
    totalPrice(e) {
      console.log(e);
      if (this.form.invoiceType == 2) {
        if (parseFloat(this.specialTicket) >= parseFloat(e)) {
          this.form.invoiceType = "1";
          this.$message.warning(
            "本产品总保费要大于" +
              this.specialTicket +
              "，才可以开增值税专用发票 "
          );
        }
      }
    },
    "form.planId"(e) {
      this.getProductPlanMoney();
    }
  }
};
</script>
<style lang="scss">
.fillIn {
  width: 100%;
  background: #eff2f4;
  background-image: url("~@/assets/images/product/main-bg.png");
  margin-top: 54px;
  overflow: hidden;
  & > .contentBox {
    width: 100%;
    max-width: 1200px;
    margin: 35px auto;
    background: #ffffff;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.07);
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    .introduce {
      background-position: right;
      background-size: auto 100%;
      background-repeat: no-repeat;
      background-image: url("~@/assets/images/product/insure_details_bg.png");
      & > div {
        margin: 30px;
        padding-bottom: 25px;
        border-bottom: 1px dotted #979797;
        position: relative;
        .tit {
          font-size: 22px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
          padding-bottom: 15px;
          span {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
            background-image: linear-gradient(to right, #ff9a5d, #f66735);
            border-radius: 15px 0px 15px 0px;
            display: inline-block;
            padding: 2px 20px;
            margin-right: 5px;
            line-height: 24px;
          }
        }
        p {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 36px;
          margin: 0;
          display: flex;
          justify-content: flex-start;
          span {
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
            max-width: calc(100% - 75px);
          }
          a {
            color: #2d8aee;
          }
        }
      }
      & > div::before,
      & > div::after {
        content: "";
        width: 34px;
        height: 34px;
        border-radius: 50%;
        display: block;
        position: absolute;
        background: #eff2f4;
        bottom: -17px;
      }
      & > div::before {
        left: -47px;
      }
      & > div::after {
        right: -47px;
      }
    }
    .stepBox {
      display: flex;
      justify-content: center;
      align-items: center;
      p {
        position: relative;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        width: 220px;
        height: 36px;
        margin: 0;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      p + p {
        margin-left: -10px;
        color: rgba(0, 0, 0, 0.85);
      }
    }
    .insureStap {
      padding: 0 30px;
      margin-top: 20px;
      overflow: hidden;
      .stapTit {
        padding: 13px 0;
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #dadada;
        p {
          font-size: 18px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin: 0;
          position: relative;
        }
        p:before {
          content: "";
          display: inline-block;
          width: 5px;
          height: 24px;
          border-radius: 0px 10px 10px 0px;
          background: #2d8aee;
          margin-right: 24px;
          position: relative;
          top: 5px;
        }
        p:after {
          content: "";
          width: 134px;
          height: 7px;
          display: inline-block;
          background: #2d8aee;
          opacity: 0.13;
          position: absolute;
          bottom: 0px;
          left: 25px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #687a95;
          line-height: 22px;
          margin-right: 8px;
          cursor: pointer;
          i {
            margin-left: 8px;
          }
        }
      }
      .stapTit.show {
        border: 1px solid #dadada;
        background: #f9f9f9;
      }
      .setpContent {
        padding-top: 25px;
        .lm0 {
          margin-bottom: 0;
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
        .el-form-item {
          margin-bottom: 25px;
          .el-form-item__label {
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .contentArea {
          padding-left: 60px;
          padding-right: 90px;
          & > .checkThree {
            margin-top: 24px;
            & > .el-checkbox {
              margin-right: 40px;
            }
            .el-radio-group {
              .el-radio {
                margin-right: 40px;
              }
            }
            i {
              font-size: 12px;
            }
          }
        }
      }

      .setpContent.one,
      .setpContent.two,
      .setpContent.three > .top {
        padding-left: 50px;
        padding-right: 90px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .el-input,
        .el-select,
        .el-cascader {
          width: 100%;
        }
        & > div {
          width: 460px;
        }
        & > .right {
          width: 420px;
          .commoSelect {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            & > p {
              font-size: 14px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              line-height: 20px;
              width: 90px;
            }
          }
          .el-upload {
            margin-top: 25px;
            .el-upload-dragger {
              background: #ffffff;
              width: 420px;
              height: 220px;
              border-radius: 4px;
              border: 1px solid #51a9fc;
              img {
                margin-top: 45px;
                margin-bottom: 20px;
              }
              .el-upload__text {
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 22px;
              }
              .el-upload__text + p {
                font-size: 12px;
                font-weight: 400;
                color: #fea119;
                line-height: 17px;
                margin: 5px 0 0;
              }
            }
          }
          .el-upload-list.custom {
            .el-image {
              display: block;
              margin-left: -80px;
              float: left;
            }
          }
          .el-upload__tip {
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 0, 0, 0.65);
            line-height: 20px;
            margin: 0;
          }
        }
      }
      .setpContent.four {
        .btnbox {
          text-align: right;
          .el-button {
            color: #2d8aee;
            border-color: #2d8aee;
          }
        }
        .tablebox + .el-button {
          border-radius: 2px;
          border: 1px dotted #2d8aee;
          font-size: 14px;
          font-weight: 400;
          color: #2d8aee;
          line-height: 20px;
          display: block;
          width: 100%;
          padding: 7px;
          margin-top: -10px;
        }
        .tablebox table th {
          background: #f5f7fa;
        }
        .el-table {
          .el-form-item {
            margin: 0;
            .el-form-item__content {
              margin-left: 0 !important;
            }
          }
          .el-table__empty-block {
            background-image: url("~@/assets/images/product/empty_tablebg.png");
            height: 102px !important;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
      .setpContent.five {
        .hint {
          background: #fdf2d4;
          border-radius: 3px;
          padding: 10px 20px;
          margin-bottom: 20px;
          p {
            font-size: 14px;
            font-weight: 400;
            color: #e7860d;
            line-height: 20px;
            margin: 0;
            i {
              margin-right: 10px;
              color: #ea0e0e;
            }
          }
        }
        .check {
          font-size: 14px;
          line-height: 1.7;
          cursor: pointer;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          padding: 40px 120px 0 90px;
          margin-top: 20px;
          margin-left: -90px;
          margin-right: -120px;
          position: relative;
          border-top: 1px dotted #dfdcdc;
          .el-checkbox {
            pointer-events: none;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .check::before,
        .check::after {
          content: "";
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: block;
          position: absolute;
          background: #eff2f4;
          top: -17px;
        }
        .check::before {
          left: -17px;
        }
        .check::after {
          right: -17px;
        }
        .flexbox {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          & > div {
            width: 460px;
            .el-input {
              width: 100%;
            }
          }
        }
        .bottomBtn {
          margin: 30px 0;
          background: #f1f5fa;
          border-radius: 12px;
          overflow: hidden;
          display: flex;
          justify-content: space-between;
          div.text {
            display: flex;
            justify-content: flex-start;
            p {
              font-size: 16px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.65);
              padding: 15px 40px;
              margin: 0;
              span {
                font-size: 20px;
                font-weight: 500;
                color: #000000;
              }
            }
            p + p > span {
              color: #f48226;
            }
          }
          div.btn {
            width: 289px;
            font-size: 25px;
            font-weight: 500;
            color: #ffffff;
            text-align: center;
            line-height: 56px;
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-image: url("~@/assets/images/product/insureOkbg.png");
          }
        }
      }
      // 电子签章
      .ESignature {
        position: absolute;
        top: 26px;
        left: 0;
        width: 60px;
        height: 60px;
        z-index: 2;
        & > div {
          img {
            width: 100%;
            transform: rotate(-90deg);
          }
          i {
            position: absolute;
            top: -5px;
            left: -20px;
            font-size: 18px;
            color: #d72322;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.el-dialog__wrapper.clauseBox {
  width: calc(100% - 18px);
  .el-dialog {
    margin-bottom: 0;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 30px;
    .hint {
      font-size: 16px;
      margin: 0;
      font-weight: 400;
      color: #ff0000;
    }
    .rollBox {
      overflow-x: auto;
      margin: 35px 0 10px;
      .el-checkbox-group {
        // white-space: nowrap;
        padding-bottom: 20px;
        max-height: 230px;
        overflow: auto;
        & > .item {
          display: block;
          // margin-right: 30px;
          margin-bottom: 5px;
          cursor: pointer;
          .el-checkbox {
            pointer-events: none;
            .el-checkbox__label {
              font-size: 16px;
              font-weight: 500;
              color: #000000;
            }
          }
        }
      }
    }
    iframe {
      width: 100%;
      height: 400px;
      border: none;
    }
    .el-button,
    .el-button:hover {
      background: #cccccc;
      color: #eeeeee;
      border-color: #cccccc;
      margin: auto;
      display: block;
      margin-top: 30px;
      cursor: not-allowed;
    }
    .el-button.active,
    .el-button.active:hover {
      background: #409eff;
      border-color: #409eff;
      cursor: pointer;
    }
  }
}
// 电子签认证提示弹窗
.el-dialog__wrapper.ishintBox {
  .hintBox {
    text-align: center;
    p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin: 5px;
      span {
        color: #5b86e0;
      }
    }
    .el-button {
      margin-top: 20px;
    }
  }
}
//电子签认证状态弹窗
.el-dialog__wrapper.isApplybox {
  .el-dialog__header {
    display: none;
  }
  .applyBox {
    text-align: center;
    img {
      margin-top: -90px;
    }
    p.tit {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      padding: 25px 0 0;
      margin: 0;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin: 15px 0 30px;
      span {
        color: #cb2d2c;
      }
    }
  }
}
</style>
